import { Panel } from 'primereact/panel';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';
import Typography from '../Typography.component';

// https://www.figma.com/design/A1suqNxo7ab0Zq7gxCiwaE/ADL-Components?node-id=9443-11003&m=dev

export const CollapsibleCard = ({
	header = '',
	children,
	className = '',
	dataqa = '',
	isCollapsed = true,
}) => {
	const [collapsed, setCollapsed] = useState(isCollapsed);

	const onclickToggle = () => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'collapsible-input-button',
				field_name_dataqa: `${dataqa}-collpsible-card-collapse-button`,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});

		setCollapsed(!collapsed);
	};

	const renderHeader = () => {
		return (
			<div className="p-panel-header">
				<span className="p-panel-title">{header}</span>
				<button
					className="p-panel-header-icon p-panel-toggler p-link"
					onClick={() => onclickToggle()}
					{...{
						dataqa: `${dataqa}-collpsible-card-collapse-button`,
					}}
				>
					<span
						className={`pi ${collapsed ? 'pi-chevron-down' : 'pi-chevron-up'}`}
					/>
				</button>
			</div>
		);
	};

	return (
		<div className={`common-ui-collapsible-card ${className}`} data-qa={dataqa}>
			<Panel
				headerTemplate={renderHeader}
				toggleable
				collapsed={collapsed}
				onToggle={e => setCollapsed(e.value)}
				id="panel-content"
			>
				{children}
			</Panel>
		</div>
	);
};

CollapsibleCard.propTypes = {
	header: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	dataqa: PropTypes.string,
	isCollapsed: PropTypes.bool,
};
